import { EducatorsInvitationsInvitation } from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"

export type NewProps = {
  invitation: EducatorsInvitationsInvitation
}

export const useNewProps = () => useProps<NewProps>()
